import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom'
import TableRowCommon from '../../../../components/table/TableRowCommon';
import { useMediaQuery, useTheme } from '@mui/material';
import OptionsButtonCustom from '../../../../components/option-button/OptionsButtonCustom';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { alertActive, alertError, alertSuccess } from '../../../../components/alert/swal';
import moment from 'moment';
import { dateTimeToView } from '../../../../utils/date.utils';
import { create_library_author, library_author_list, LibraryAuthorApi } from '../../../../api/library-author/library_author.api';


export const useManageState = () => {
    // CONSTANCE
    const dispatch = useDispatch();
    const location = useLocation();
    const pathname = location.pathname;
    const { t } = useTranslation();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));


    const [formState, setFormState] = useState<create_library_author>({
        id_library_author: null,
        library_author_name: ""
    })

    // HOOKS
    const [search, set_search] = useState<string>("");
    const [start_date, set_start_date] = useState<string | null>(null);
    const [end_date, set_end_date] = useState<string | null>(null);
    const [category_library, set_category_library] = useState<string>("");

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("created_date");
    const [sortType, setSortType] = useState<string>("DESC");
    const [data, set_data] = useState<any[]>([]);
    const [showModal, set_showModal] = useState<string>("");

    const handleCloseModal = () => {
        set_showModal("");
        setFormState({ library_author_name: "", id_library_author: null });
    }
    const handleChangeDateRange = (st: string | null, end: string | null) => {
        set_start_date(st);
        set_end_date(end);
    }

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_library_author", width: 50, sortable: false, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "left", label: t("ชื่อ")
        },
        {
            id: "4", disablePadding: false, align: "center", width: 141, label: t("ผู้ที่สร้าง/ปรับปรุงล่าสุด")
        },
        {
            id: "5", disablePadding: false, align: "center", width: 141, label: t("วันที่สร้าง/ปรับปรุงล่าสุด")
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            library_author_name,
            created_by,
            modified_date,

            id_library_author,
            modified_by
        } =
            objData;

        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no },
                {
                    option: "TEXT",
                    align: "left",
                    label: library_author_name || "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: modified_by || created_by || "-"
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <OptionsButtonCustom
                            enableEdit
                            enableView
                            enableDelete
                            onViewClick={() => {
                                set_showModal("VIEW");
                                setFormState({
                                    id_library_author: id_library_author, library_author_name
                                });
                            }}
                            onEditClick={() => {
                                set_showModal("EDIT");
                                setFormState({
                                    id_library_author: id_library_author, library_author_name
                                });
                            }}
                            onDeleteClick={() => handleDeleteList(id_library_author)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleDeleteList = (id_library_type: number) => {
        alertActive("ลบรายการ", "ท่านต้องการลบรายการนี้?", undefined, undefined, async () => {
            dispatch(setLoading());
            await LibraryAuthorApi.delete(id_library_type).then((res) => {
                if (res.status < 300) {
                    alertSuccess("ลบรายการ", "ลบรายการ เรียบร้อยแล้ว");
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError("ลบรายการ", "ลบรายการ เรียบร้อยแล้ว")
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const generateBody = (): create_library_author => {
        return {
            library_author_name: formState.library_author_name,
        }
    }

    const handleSubmit = async () => {
        const body = generateBody();
        dispatch(setLoading());
        if (formState.id_library_author) {
            await LibraryAuthorApi.update(formState.id_library_author, body).then((res) => {
                if (res.status < 300) {
                    handleGetData();
                    handleCloseModal();
                    alertSuccess("อัพเดตหมวดหมู่", "อัพเดตหมวดหมู่ สำเร็จ");
                }
            }).catch((err) => {
                console.log(err);
                alertError("อัพเดตหมวดหมู่", "อัพเดตหมวดหมู่ ไม่สำเร็จ");
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {

            await LibraryAuthorApi.create(body).then((res) => {
                if (res.status < 300) {
                    handleGetData();
                    handleCloseModal();
                    alertSuccess("เพิ่มหมวดหมู่", "เพิ่มหมวดหมู่ สำเร็จ");
                }
            }).catch((err) => {
                console.log(err);
                alertError("เพิ่มหมวดหมู่", "เพิ่มหมวดหมู่ ไม่สำเร็จ");
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
        // console.log(body, 'body');
    }

    const handleGetData = useCallback(async () => {
        let query: library_author_list = {
            page: page,
            limit: pageLimit,
            sortBy: sortBy,
            sortType: sortType
        }
        if (search) query.search = search
        if (category_library) query.category_library = category_library
        if (start_date) query.start_date = moment(start_date).format("YYYY-MM-DD");
        if (end_date) query.start_date = moment(end_date).format("YYYY-MM-DD");
        dispatch(setLoading());
        await LibraryAuthorApi.list(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                setTotalItems(res.data?.data?.meta?.totalItems || 0);
                set_data(response)
                // console.log(response, 'data')
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, sortBy, sortType, category_library, start_date, end_date, search])

    useEffect(() => {
        handleGetData();
    }, [handleGetData])

    return {
        pathname,
        set_search,
        handleChangeDateRange,
        start_date,
        end_date,
        page,
        pageLimit,
        totalItems,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        showModal,
        handleCloseModal,
        set_showModal,
        handleSubmit,
        category_library,
        set_category_library,
        setFormState,
        formState
    }
}

